import { Component, ViewChild } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CarouselModule } from 'ngx-owl-carousel-o';

import { MatAutocomplete, MatAutocompleteModule, MatAutocompleteTrigger } from '@angular/material/autocomplete';

import { FormControl } from '@angular/forms';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { Observable, startWith, map } from 'rxjs';
import { OOModule } from '../../modules/oo.module';
import { environment } from '../../environments/environment';
import { HomeService } from './home.service';
import { StorageService } from '../../services/storage/storage.service';
import { RewardService } from '../../services/shared/reward.service';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { NotificationService } from '../../services/shared/notifications.service';
import { SESSION_CART, SESSION_CUSTOMER_ACTIVE_REWARDS, SESSION_NEAREST_SHOP_LIST, SESSION_SHOP_LIST, SESSION_DEPARTMENT_LIST, SESSION_AMENITY_LIST, SESSION_SYSTEM_SETTINGS, SESSION_PICKUP_LOCATION_LIST, SESSION_OFFERS, SESSION_FILTERED_OFFERS, SESSION_SALE_ITEM_LIST, SESSION_START_TIME, SESSION_AUTHENTICATED_CUSTOMER, SESSION_ONLINE_SERVICE_LIST, SESSION_BUSINESS_TYPE_LIST, SESSION_ITEM_CATEGORY_LIST, SESSION_APPLIED_REWARDS, SESSION_SELECTED_SHOP, SESSION_CUSTOMER_REWARDS, SESSION_COMPANY_INFO, PROMOTION_ELIGIBILITY_TYPE_OFFER, SESSION_MASTER_CUSTOMIZATION, SESSION_MASTER_COMBO_CUSTOMIZATION, SESSION_SHOW_NOTICE, SESSION_BANNER_LIST, SESSION_OPERATION_MODE, SESSION_FILTERED_SALE_ITEM_LIST, SESSION_FILTERED_CATEGORY_ITEM_LIST, SESSION_FILTERED_OTHERS_CATEGORY_ITEM_LIST } from '../../app.constants';


import { CartService } from '../../services/cart/cart.service';
import { ItemListService } from '../../services/shared/item-list.service';
import { SettingsService } from '../../services/shared/settings.service';
import { UtilService } from '../../services/shared/util.service';
import { PromotionCardComponent } from './components/promotion-card/promotion-card.component';
import { CustomerService } from '../../services/customer/customer.service';
import { CommonModule } from '@angular/common';
import { OrderScheduleComponent } from '../order-schedule/order-schedule.component';
import { MatDialog } from '@angular/material/dialog';
import { GtmService } from '../../services/shared/gtm.service';
import { SplashComponent } from '../splash/splash.component';
import { SplashService } from '../splash/splash.service';
import { ShownoticeComponent } from "../shownotice/shownotice.component";
import { DomSanitizer } from '@angular/platform-browser';
import moment from 'moment';
import { BannerService } from './banner.service';
import { DateTimeServiceService } from '../../services/shared/date-time-service.service';
import { MessageDialogService, NotificationDialogModel } from '../../services/shared/message-dialog.service';


@Component({
  selector: 'app-home',
  imports: [OOModule,
    CarouselModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    RouterModule,
    PromotionCardComponent,
    CommonModule,
    SplashComponent, ShownoticeComponent],
  providers: [],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss', '../../../assets/css/quill.snow.css']
})
export class HomeComponent {
  recentOrderList: any;
  lastOrderShopName: any;
  customerName: any;
  rewardsData: any;
  offersData: any;
  isRegionListOpen: any;
  showError = false;
  locationCoordinateData: any;
  selectedLocation: any;
  RegionCurrentLocationId = 100000;
  radius: any;
  selectedShopList: any = [];
  isCurrentLocationAvilable = false;
  nearestShopList: any = [];
  nearestShopArray: any;
  shopList: any = [];
  departmentList: any = [];
  amenities: any;
  crmAssetsUrl = environment.crm.assetsUrl;
  oosAssetsUrl = environment.oos.assetsUrl;
  searchControl = new FormControl('');
  filteredShopList: any = [];
  customizationOptionValues: any;
  systemSettings: any;
  currencySymbol: any;
  lastOrderShopId: any;
  saleItemList: any;
  businessTypeList: any;
  itemCategoryList: any;
  promotion: any;
  appliedRewards: any = [];
  defaultShop: any;
  cart: any;
  selectedShop: any;
  deliveryDate: any;
  deliveryTime: any;
  deliveryMethod: any;
  deliveryDateTime: any;
  buildNo: any;
  showBuildNo: boolean;
  customerInfo: any;
  companyInfo: any = [];
  @ViewChild('homeSearch') homeSearch!: MatAutocompleteTrigger;
  isOrderScheduleTrgd: boolean = false;
  bentoDpt: any;
  isRewardsAvailable: boolean = false;
  customizationComboOptionValues: any;
  showSplash: boolean;
  intervalId: any;
  visibility: any;
  loginstatus: boolean = false;
  bannerData: any;
  bannerUrl: string;
  redirectParams: any;
  deliverectShopCodes: any = [];
  deliverectUrl: string = '';





  constructor(private homeService: HomeService,
    private storageService: StorageService,
    private rewardService: RewardService,
    private router: Router,
    private notificationService: NotificationService,
    private cartService: CartService,
    private itemListService: ItemListService,
    private settingsService: SettingsService,
    private itemService: ItemListService,
    private utilService: UtilService,
    private customerService: CustomerService,
    public dialog: MatDialog,
    private gtmService: GtmService,
    private splashService: SplashService,
    private bannerService: BannerService,
    private sanitizer: DomSanitizer,
    private route: ActivatedRoute,
    private dateTimeServiceService: DateTimeServiceService,
    private messageDialogService: MessageDialogService) {

    this.buildNo = environment.buildNo;
    this.bannerUrl = environment.oos.assetsUrl + '/images/banner';
    this.showBuildNo = false;
    this.showSplash = this.showSplash = this.splashService.show();
    if (this.showSplash) {
      this.intervalId = setInterval(() => {
        this.showSplash = this.splashService.show();
        if (!this.showSplash) {
          clearInterval(this.intervalId);
          this.instoreQrOrdering();
        }
      }, 1000);
    }
  }

  instoreQrOrdering() {
    if (this.cartService.cart?.deliveryTime) {
      console.log('Skipping: Delivery time already set in cart');
      return;
    }
    if (this.redirectParams) {
      // Validate redirectParams structure
      if (!this.isValidRedirectParams(this.redirectParams)) {
        console.error('Invalid redirectParams structure:', this.redirectParams);
        this.showInvalidUrlMessage();
        return;
      }

      const parameters = JSON.parse(this.storageService.loadFromSession(SESSION_OPERATION_MODE));
      if (parameters == null && parameters == undefined) {
        this.storageService.saveToSession(SESSION_OPERATION_MODE, JSON.stringify(this.redirectParams));
      }

      const scode = this.redirectParams.shop;

      // Find shop from shopList by scode
      const shop = this.shopList.find((s: any) => s.code === scode);

      if (!shop) {
        console.warn('Shop not found for scode:', scode);
        return;
      }

      // Hardcoded business type
      const allBusinessTypes = JSON.parse(this.storageService.loadFromSession(SESSION_BUSINESS_TYPE_LIST));
      const businessType = allBusinessTypes[0];
      // Prepare delivery date
      const now = new Date();
      const dayName = now.toLocaleDateString('en-US', { weekday: 'short' }); // e.g., Tue
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const dateStr = `${year}/${month}/${day}`; // e.g., 2025/07/08

      const deliveryDate = {
        date: dateStr,
        label: `TODAY (${dayName})`,
        isClosed: false
      };

      // Prepare delivery time (current time + initialDelay)
      const currentMoment = moment();
      const deliveryTimeMoment = currentMoment.add(2, 'minutes').add(businessType.initialDelay, 'minutes');
      const deliveryTime = deliveryTimeMoment.format('HH:mm:ss'); // e.g., 17:15:00

      // Save all to cart
      this.cartService.setShop(shop);
      this.cartService.setDeliveryDate(deliveryDate);
      this.cartService.setDeliveryTime(deliveryTime);
      this.cartService.setBusinessType(businessType); // businessType is treated as service here

      const businessTypeId = this.cartService.cart.businessType.id;
      const pickUpDate = this.cartService.cart.deliveryDate.date;

      /**
       * get the filterd sale items
       */
      let salesChannel: string[] = [];
      const mode = this.redirectParams.mode
      salesChannel.push(
        ...(mode === 'INSTORE' ? ['instore'] :
          mode === 'ONLINE' ? ['online'] :
            ['instore', 'online'])
      );
      this.itemListService.loadSaleItemExt(businessTypeId, pickUpDate, this.cartService.cart.shop, salesChannel).subscribe(res => {
        const saleItemList = res.object;
        // console.log(saleItemList)
        this.storageService.saveToSession(SESSION_FILTERED_SALE_ITEM_LIST, JSON.stringify(saleItemList));

        const categoryList = JSON.parse(this.storageService.loadFromSession(SESSION_ITEM_CATEGORY_LIST));
        const merchantSaleItemList = (saleItemList || []).filter((item: any) => item.itemType === 1 || item.itemType === 2 || item.itemType === 3);
        const filteredCategory = this.itemListService.getFilteredItemCategoryList(categoryList, merchantSaleItemList);
        this.storageService.saveToSession(SESSION_FILTERED_CATEGORY_ITEM_LIST, JSON.stringify(filteredCategory));

        const nonMerchantSaleItemList = (saleItemList || []).filter((item: any) => item.itemType === 4);
        const filteredOthersCategory = this.itemListService.getFilteredItemCategoryList(categoryList, nonMerchantSaleItemList);
        this.storageService.saveToSession(SESSION_FILTERED_OTHERS_CATEGORY_ITEM_LIST, JSON.stringify(filteredOthersCategory));

        let inputParam = { "shop_id": shop.id, "pickUp_date_time": this.cartService.cart.deliveryDate.date + " " + this.cartService.cart.deliveryDate.time };
        this.dateTimeServiceService.getOutofStockByShop(inputParam);

        // Only navigate AFTER session is updated
        sessionStorage.setItem('shopRedirectDone', 'true');
        this.router.navigate(['/shopItem']);
      });
    }
  }
  /**
   * Show the banner according to the date
   * @returns 
   */
  showTeaser(): boolean {
    var dateFrom = moment(new Date("2024-09-24"), "yyyy-MM-dd");
    var dateTo = moment(new Date("2024-09-30"), "yyyy-MM-dd");
    var currentDate = moment(new Date(), "yyyy-MM-dd");
    var show = (currentDate.isBetween(dateFrom, dateTo, 'day', '[]'));
    return show;
  }

  showGiveAway(): boolean {
    var dateFrom = moment(new Date("2025-06-23 00:00:00"), "yyyy-MM-dd HH:mm:ss");
    var dateTo = moment(new Date("2025-08-24 23:59:59"), "yyyy-MM-dd HH:mm:ss");
    var currentDate = moment(new Date(), "yyyy-MM-dd HH:mm:ss");
    var show = (currentDate.isBetween(dateFrom, dateTo, 'day', '[]'));
    return show;
  }

  /***Options slides defined for Rewards***/
  homeSlides: OwlOptions = {
    loop: false,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    navSpeed: 700,
    autoWidth: false,
    responsive: {
      0: {
        items: 1,
        margin: 12,
      },
      552: {
        items: 1,
        margin: 12
      },
      740: {
        items: 2,
        margin: 12
      },
      968: {
        items: 3,
        margin: 12
      },
      1040: {
        items: 10,
        margin: 30,

      }
    },
    nav: false
  }

  /***Options slides defined for Special offers***/
  orderSlides: OwlOptions = {
    loop: false,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    navSpeed: 700,
    navText: ['<', '>'],
    responsive: {
      0: {
        items: 1,
        margin: 10
      },
      552: {
        items: 2,
        margin: 10
      },
      740: {
        items: 3,
        margin: 10
      },
      968: {
        items: 3,
        margin: 10,
      },
      1040: {
        items: 3,
        margin: 30
      }
    },
    nav: false
  }

  ngOnInit() {
    this.utilService.scrollToTop();
    if (sessionStorage.getItem('shopRedirectDone') === 'true') {
      this.router.navigate(['/shopItem']);; // Prevent re-redirect when navigating back
    }
    this.route.queryParams.subscribe(params => {
      const qp = params['qp'];
      if (qp) {
        try {
          this.redirectParams = JSON.parse(decodeURIComponent(qp));
          this.showSplash = false; // skip splash if coming from QR
          this.instoreQrOrdering(); // ?? immediately call
          this.router.navigate([], {
            relativeTo: this.route,
            queryParams: {},
            replaceUrl: true
          });
        } catch (e) {
          console.error('Invalid qp format:', e);
          this.showSplash = false;
        }
      } else {
        this.showSplash = this.splashService.show();
        if (this.showSplash) {
          this.intervalId = setInterval(() => {
            this.showSplash = this.splashService.show();
            if (!this.showSplash) {
              clearInterval(this.intervalId);
              // this.instoreQrOrdering(); ?? only if no redirectParams
            }
          }, 1000);
        }
      }
    });
    this.setMasterData();
    this.searchControl.valueChanges.subscribe(searchTerm => {
      this.filterShops();
    });

    this.appliedRewards = JSON.parse(this.storageService.loadFromSession(SESSION_APPLIED_REWARDS));
    if (this.appliedRewards == undefined) {
      this.appliedRewards = [];
    }
    this.notificationService.recentOrders.subscribe(recentOrder => {
      this.recentOrderList = recentOrder;
      this.lastOrderShopName = this.recentOrderList[0].shopName;
      this.lastOrderShopId = this.recentOrderList[0].shopId;
    });

    this.notificationService.userLoginChanged.subscribe(status => {
      if (status == 'in') {
        this.loginstatus = true;
        this.customerInfo = this.cartService.cart.customer;
        this.customerName = this.customerInfo?.firstName;
        this.storageService.saveToSession(SESSION_AUTHENTICATED_CUSTOMER, JSON.stringify(this.customerInfo));
        this.recentOrders();
        this.setRewards();
      }
      else {
        this.recentOrderList = undefined;
        this.rewardsData = undefined;
        this.customerName = undefined;
        this.lastOrderShopName = undefined;
        this.lastOrderShopId = undefined;
      }
    });
  }

  /**
   * SET all Master Data into the session
   */
  setMasterData() {
    this.setCompanyInfo();
    this.setCustomerInfo();
    this.setAllShop();
    this.setAllSaleItem();
    this.setAllDepartments();
    this.setCustomizationOptionDtl();
    this.setSystemSettings();
    this.setPickUpLoacations();
    this.filterShops();
    this.recentOrders();
    this.setOffers();
    this.setRewards();
    this.setAmenities();
    this.setOnlineServices();
    this.setBusinessType();
    this.setItemCategoryList();
    this.setDefaultShop();
    this.getBannerData();
    const now = new Date();
    this.storageService.saveToSession(SESSION_START_TIME, now)
  }

  /*** When the user is logged IN Pick the details of the user ***/
  setCustomerInfo() {
    this.customerInfo = this.cartService.cart.customer;
    this.customerName = this.customerInfo?.firstName;
  }

  /*** When the user is logged IN Pick the recent orders of the user ***/
  recentOrders() {
    if (this.cartService.cart.customer !== undefined && this.cartService.cart.customer.customerType !== 2) {
      this.cartService.getRecentOrder(this.cartService.cart.customer?.id).subscribe((recentOrderData: any) => {
        // this.cartService.setRecentOrderCustomerToCart(recentOrderData.object.recentOrder);
        this.recentOrderList = JSON.parse(recentOrderData.object.recentOrder);
        if (this.recentOrderList !== null && this.recentOrderList !== undefined && this.recentOrderList.length != 0) {
          this.lastOrderShopName = this.recentOrderList[0].shopName;
          this.lastOrderShopId = this.recentOrderList[0].shopId;
          this.notificationService.notifyRecentOrder(this.recentOrderList);
        }
      });
    }
    // const cart = this.cartService.cart;
    // if ((cart != null && cart != undefined) && (cart.customer != null && cart.customer != undefined)) {
    //   if (cart.customer.recentOrder !== null && cart.customer.recentOrder !== undefined) {
    //     this.recentOrderList = JSON.parse(cart.customer.recentOrder);
    //     this.lastOrderShopName = this.recentOrderList[0].shopName;
    //   this.lastOrderShopId = this.recentOrderList[0].shopId;
    //     this.notificationService.notifyRecentOrder(this.recentOrderList);
    //   }
    // }
  }

  /** SET All pickup locations**/
  setPickUpLoacations() {
    this.homeService.getPickUpLocations().subscribe((locations: any) => {
      const pickUplocations = JSON.stringify(locations.object);
      this.storageService.saveToSession(SESSION_PICKUP_LOCATION_LIST, pickUplocations);
    });
  }

  /** SET All Shops**/
  setAllShop() {
    this.homeService.getShops().subscribe((shopdata: any) => {
      this.shopList = shopdata.object;
      this.markDeliverectShops();
      // this.filteredShopList = this.shopList;
      this.filteredShopList = this.shopList.sort(function (a: any, b: any) {
        if (a.name < b.name) return -1; // Sort ascending (a before b)
        if (a.name > b.name) return 1; // Sort ascending (b before a)
        return 0; // Equal names
      });
      this.storageService.saveToSession(SESSION_SHOP_LIST, JSON.stringify(this.shopList));

      if (this.redirectParams) {
        this.instoreQrOrdering();
      }
    });
  }

  markDeliverectShops() {
    if (this.shopList && this.shopList.length > 0) {
      this.shopList.forEach((shop: any) => {
        shop.isDeliverect = this.deliverectShopCodes.includes(shop.code);
        shop.showRegularButtons = false;
      });
    }
  }

  openDeliverectUrl(event: any) {
    event.stopPropagation();
    const url = this.deliverectUrl;
    window.open(url, '_blank');
  }




  /**
   * set the default shop of user
   */
  setDefaultShop() {
    this.cart = this.cartService.cart;
    if (this.cart.shop !== null && this.cart.shop !== undefined) {
      this.defaultShop = this.cart.shop;
      this.selectedShop = this.cartService.getShop();
      this.deliveryDate = this.cartService.getDeliveryDate();
      this.deliveryTime = this.cartService.getDeliveryTime();
      this.deliveryMethod = this.cartService.getService();
      this.deliveryDateTime = this.deliveryDate.date + " " + this.deliveryTime;
    }
    else {
      this.setCustomerInfo();
    }
  }

  navigateToshopList() {
    this.router.navigate(['/shopList']);
  }

  /** SET All Sale ITEMS**/
  setAllSaleItem() {
    this.itemListService.loadSaleItem().subscribe((saleItem: any) => {
      this.saleItemList = saleItem.object;
      this.storageService.saveToSession(SESSION_SALE_ITEM_LIST, JSON.stringify(this.saleItemList));
    });
  }

  /***GET all online services and save into session */
  setOnlineServices() {
    const instoreModeParam = JSON.parse(this.storageService.loadFromSession(SESSION_OPERATION_MODE));
    this.customerService.getOnlineService().subscribe((service: any) => {
      const onlineServices = service.object;
      let pickupService;
      if (instoreModeParam && instoreModeParam.origin === 'table-qr') {
        pickupService = onlineServices.find((service: any) => service.code == 'QRDINEIN');
      } else if (instoreModeParam && instoreModeParam.origin === 'counter-qr') {
        pickupService = onlineServices.find((service: any) => service.code == 'QRPICKUP');
      } else {
        pickupService = onlineServices.find((service: any) => service.code == 'PICKUP');
      }
      this.cartService.setService(pickupService);
      this.storageService.saveToSession(SESSION_ONLINE_SERVICE_LIST, JSON.stringify(onlineServices));
    });
  }

  /***GET all amentities and save into session */
  setAmenities() {
    this.customerService.getAmenities().subscribe((amentites: any) => {
      this.amenities = JSON.stringify(amentites.object);
      this.storageService.saveToSession(SESSION_AMENITY_LIST, this.amenities);
    });
  }

  /***GET All business Types */
  setBusinessType() {
    this.customerService.getBusinessType().subscribe((businessType: any) => {
      this.businessTypeList = JSON.stringify(businessType.object);
      this.storageService.saveToSession(SESSION_BUSINESS_TYPE_LIST, this.businessTypeList);
    });
  }

  /***GET All Items Types */
  setItemCategoryList() {
    this.customerService.getItemList().subscribe((item: any) => {
      this.itemCategoryList = JSON.stringify(item.object);
      this.storageService.saveToSession(SESSION_ITEM_CATEGORY_LIST, this.itemCategoryList);
    });
  }
  /** SET All Departments**/
  setAllDepartments() {
    this.homeService.getDepartments().subscribe((departmentdata: any) => {
      this.storageService.saveToSession(SESSION_DEPARTMENT_LIST, JSON.stringify(departmentdata.object));
      this.departmentList = JSON.parse(this.storageService.loadFromSession(SESSION_DEPARTMENT_LIST));
      this.bentoDpt = this.departmentList?.find((dpt: any) => dpt.code == 'BENTO');
    });
  }

  /**
   * Determins the notice to show or not
   * @returns 
   */
  showNotice(): boolean {
    var result: boolean = false;
    const sessionData = this.storageService.loadFromSession(SESSION_SHOW_NOTICE);
    if (sessionData === null) {
      result = (this.companyInfo !== undefined && this.companyInfo.showInfoPage);
    }

    return result;
  }

  closeNotice() {

  }

  setCompanyInfo() {
    this.homeService.getCompanyInfo().subscribe((companydata: any) => {
      this.companyInfo = companydata.object[0];
      if (this.companyInfo && this.companyInfo.deliverect) {
        this.deliverectShopCodes = this.companyInfo.deliverect.shops || [];
        this.deliverectUrl = this.companyInfo.deliverect.url;
        this.markDeliverectShops();
      }
      this.storageService.saveToSession(SESSION_COMPANY_INFO, JSON.stringify(this.companyInfo));

    });
  }


  /**** GET all offers for all customers****/
  setOffers() {
    const validOffers: any = [];
    const offerPayload = { "search": { "filters": { "simpleSearch": [], "advSearch": [], "scope": { "limit": "100", "offset": "0" } }, "sort": [] } }
    this.homeService.offers(offerPayload).subscribe((data: any) => {
      this.offersData = data.data.offers;

      // Process offers to handle is_external=1 condition
      if (this.offersData !== undefined && this.offersData !== null) {
        this.offersData.forEach((offer: any) => {
          // Check if external_url exists before processing
          if (offer.external_url !== null && offer.external_url !== undefined) {
            const externalOffer = this.externalOffer(offer.external_url);
            // console.log(externalOffer?.type);

            // If is_external = 1, set external_url as empty
            if (offer.is_external === 1 && externalOffer?.type == 'html') {
              offer.external_url = '';
            }
          }
        });
      }

      // if(this.offersData !== undefined && this.offersData.length !== 0){
      //   this.offersData.forEach((offer:any) =>{
      //     const isValidOffer=this.rewardService.offerItemvalidation(offer);
      //     if(isValidOffer==true){
      //       validOffers.push(offer);
      //     }
      //   });
      // }
      this.storageService.saveToSession(SESSION_OFFERS, JSON.stringify(this.offersData));
      this.storageService.saveToSession(SESSION_FILTERED_OFFERS, []);
      if (this.offersData !== undefined && this.offersData !== null) {
        var offers = this.offersData.filter((offer: any) => offer.reward_eligibility == 1);
        this.storageService.saveToSession(SESSION_FILTERED_OFFERS, JSON.stringify(offers));
      }
    });
  }

  externalOffer(value: string): { type: string; content: string } | undefined {
    // Add null safety check
    if (!value || value === null || value === undefined) {
      return undefined;
    }

    const pipeIndex = value.indexOf('|');
    if (pipeIndex !== -1) {
      const beforeContent = value.substring(0, pipeIndex);
      const afterContent = value.substring(pipeIndex + 1);
      return { type: beforeContent, content: afterContent };
    } else {
      return undefined;
    }
  }
  /**
   * decided which offers to show when logged in and logged out
   */
  canShowOffers(offerData: any): boolean {
    var visible = false;
    if (offerData !== undefined && offerData.length > 0) {
      if (this.cartService.isGuestLogin() && offerData.some((offer: any) => offer.show_in_offers == 1)) {
        visible = true;
      }
      else if (offerData.some((offer: any) => offer.show_in_offers == 1 && offer.reward_eligibility == PROMOTION_ELIGIBILITY_TYPE_OFFER)) {
        visible = true;
      }
    }
    return visible;
  }

  setCustomizationOptionDtl() {
    //Set customization option in item
    this.itemListService.loadCustomizationOptionDtl().subscribe(
      res => {
        this.customizationOptionValues = JSON.parse(res.object);
        this.storageService.saveToSession(SESSION_MASTER_CUSTOMIZATION, JSON.stringify(this.customizationOptionValues));
      });
    //Set customization option values in combos
    this.itemListService.loadCustomizationComboOptionDtl().subscribe(
      res => {
        this.customizationComboOptionValues = JSON.parse(res.object);
        this.storageService.saveToSession(SESSION_MASTER_COMBO_CUSTOMIZATION, JSON.stringify(this.customizationComboOptionValues));
      });
  }

  setSystemSettings() {
    this.settingsService.loadSystemSettings().subscribe(
      res => {
        this.systemSettings = res.object;
        this.storageService.saveToSession(SESSION_SYSTEM_SETTINGS, JSON.stringify(this.systemSettings));
        this.currencySymbol = this.systemSettings.currency.symbol
      }
    );
  }

  /**
   * Retrieves banner data for the home page.
   *
   * This method first attempts to load banner data from session storage.
   * If the data exists, it sets the banner data directly.
   * If not, it fetches the banner data from the server via the `bannerService`,
   * saves it to session storage for future use, and then sets the banner data.
   */
  getBannerData() {
    const allBanners = JSON.parse(this.storageService.loadFromSession(SESSION_BANNER_LIST));
    if (allBanners !== null && allBanners !== undefined) {
      this.setBannerData(allBanners);
    } else {
      this.bannerService.getBannerData().subscribe(res => {
        const allBanners = res.object;
        this.storageService.saveToSession(SESSION_BANNER_LIST, JSON.stringify(allBanners));
        this.setBannerData(allBanners);
      });
    }
  }

  setBannerData(allBanners: any) {
    const currentDate = moment();
    this.bannerData = allBanners.filter((banner: any) => {
      if (!banner.periodFrom || !banner.periodTo) {
        return true; // always show if no restriction
      }
      const from = moment(banner.periodFrom, "YYYY-MM-DD");
      const to = moment(banner.periodTo, "YYYY-MM-DD");
      return currentDate.isBetween(from, to, 'day', '[]');
    });
  }

  /**** GET all Rewards for logined customer****/
  setRewards() {
    const cart = this.cartService.getCart();
    const customer = cart.customer;
    const validReward: any = [];
    if ((customer != null && customer != undefined && customer.customerType != 2)) {
      this.rewardService.loadCustomerRewards(customer.id).subscribe(response => {
        var reward = response.data.customer_reward;
        if (reward !== undefined && reward !== null) {
          //   var offers=this.rewardService.getSessionOfferList();
          this.storageService.saveToSession(SESSION_CUSTOMER_REWARDS, JSON.stringify(reward));
          // reward.forEach((reward:any) =>{
          //   if(offers.some((offer:any) => offer.id == reward.id)){
          //     validReward.push(reward);
          //   }
          //   });
          const activeRewards = reward.filter((cr: any) => cr.customer_status == 1);
          // const activeRewards = validReward.filter((cr:any) => cr.customer_status==1);
          this.rewardsData = activeRewards;
          if (this.rewardsData.length) {
            this.isRewardsAvailable = true;
          } else {
            this.isRewardsAvailable = false;
          }
          this.storageService.saveToSession(SESSION_CUSTOMER_ACTIVE_REWARDS, JSON.stringify(activeRewards));
          this.notificationService.notifyRewardsLoaded(this.rewardsData);
        } else {
          this.rewardsData = undefined;
          this.storageService.saveToSession(SESSION_CUSTOMER_REWARDS, []);
          this.storageService.saveToSession(SESSION_CUSTOMER_ACTIVE_REWARDS, []);
        }
      });
    }
  }

  // rewardAutoApply(reward:any){
  //   this.appliedRewards.forEach((rewd:any) => {
  //     if(rewd.id !== reward.id){
  //       this.appliedRewards.push(reward)
  //       this.storageService.saveToSession(SESSION_APPLIED_REWARDS, JSON.stringify(this.appliedRewards));
  //       this.notificationService.notifyRewardChange(this.appliedRewards);
  //     }
  //   });
  // }

  getCurrentLocation() {
    if (navigator) {
      navigator.geolocation.getCurrentPosition(
        pos => {
          const lng = +pos.coords.longitude;
          const lat = +pos.coords.latitude;
          this.locationCoordinateData = { 'longitude': lng, 'latitude': lat, 'radius': environment.oos.initialRad };
          this.getShopListByLocation(this.locationCoordinateData);
        },
        err => {
          if (this.selectedLocation.id === this.RegionCurrentLocationId) {
            this.selectedShopList = [];
          }
        },
        {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 0
        }
      );
    }
  }

  /* Selecting shop list of nearest location*/
  getShopListByLocation(locationData: any) {
    this.isCurrentLocationAvilable = false;
    this.shopList = JSON.parse(this.storageService.loadFromSession(SESSION_SHOP_LIST));
    this.homeService.getNearestShops(locationData).subscribe(
      (res) => {
        this.nearestShopList = res.object;
        this.storageService.saveToSession(SESSION_NEAREST_SHOP_LIST, JSON.stringify(this.nearestShopList));
        this.router.navigate(['/shopList']);
      }
    );
  }

  filteredOptions!: Observable<string[]>;

  filterShops() {
    const searchTerm = this.searchControl.value?.toLocaleLowerCase();

    // Filter the shopList using JavaScript's filter() method
    this.filteredShopList = this.shopList.filter((shop: any) => {
      return shop.name.toLowerCase().includes(searchTerm);
    });
  }


  //For reordering the order Again
  orderDetails(orderId: any) {
    this.router.navigate(['/order-details'], { queryParams: { 'id': orderId, 'src': "reorder" } });
  }

  /**
   * For normal Item selection and add to the cart
   * @param buzType 
   * @param shop 
   */
  scheduleDialog(buzType: any, shop: any) {
    this.gtmService.pushEvent("click_and_collect", {
      selection: buzType,
      visitorType: this.gtmService.getVisitorType()
    })
    const dlgData = { businessType: buzType, shop: shop, redirectUrl: '/shopItem', msg: "" }
    this.dialog.open(OrderScheduleComponent, {
      panelClass: 'schedule-dialog',
      data: dlgData
    });
    this.isOrderScheduleTrgd = true;
    if (this.homeSearch !== undefined) {
      this.homeSearch.closePanel();
    }
  }


  // /**
  //  * For offer Item add to cart for this already item added and after that shop selection
  //  * @param buzType 
  //  * @param shop 
  //  */
  // navigateForOfferSelection(buzType: any, shop: any) {
  //   const dlgData = { businessType: buzType, shop: shop, redirectUrl: '/shoppingCart', msg: "" }
  //   this.dialog.open(OrderScheduleComponent, {
  //     panelClass: 'schedule-dialog',
  //     data: dlgData
  //   });
  // }

  isBentoShop(shop: any): boolean {
    // const shop = this.shopList.find((s: any) => s.id == shopId);
    const shopDepartmentList = shop.department;
    // const bentoDpt = this.departmentList?.find((dpt: any) => dpt.code == 'BENTO');
    const shopBentodpt = shopDepartmentList?.find((dpt: any) => dpt == this.bentoDpt.id);
    return (shopBentodpt !== undefined && shopBentodpt !== null);
  }

  navigateToShopDetail(shopId: any) {
    if (!this.isOrderScheduleTrgd) {
      this.router.navigate(['shopDetail/' + shopId]);
    }
    this.isOrderScheduleTrgd = false;
  }

  /**
   * Validates redirectParams structure based on QR code type
   * @param params redirectParams object to validate
   * @returns boolean indicating if params are valid
   */
  private isValidRedirectParams(params: any): boolean {
    // Check if required fields exist
    if (!params.mode || !params.origin || !params.shop) {
      console.error('Missing required fields: mode, origin, or shop');
      return false;
    }

    // If origin is table-qr, table field must exist and not be null/empty
    if (params.origin === 'table-qr') {
      // if (!params.table || params.table === null || params.table === '') {
      //   console.error('Table field is required for table-qr origin but is missing or empty');
      //   return false;
      // }
    }

    // Additional validation for counter-qr (table can be empty)
    if (params.origin === 'counter-qr') {
      // Table field can be empty or null for counter QR codes
      console.log('Valid counter QR parameters');
    }

    return true;
  }

  /**
   * Shows invalid URL message to the user
   */
  private showInvalidUrlMessage(): void {
    alert('Invalid QR Code: The scanned QR code is not valid or is missing required information. Please try scanning a different QR code or contact staff for assistance.');
    // Clear the invalid redirectParams
    this.redirectParams = null;
    // Clear the URL query parameters
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {},
      replaceUrl: true
    });

    sessionStorage.removeItem(SESSION_OPERATION_MODE);
    this.router.navigate(['/']);

    // const msg = 'Invalid QR Code: The scanned QR code is not valid or is missing required information. Please try scanning a different QR code or contact staff for assistance.';
    // var dlgData: NotificationDialogModel = {
    //   message: msg,
    //   title: `Sorry!`,
    //   yesButtonCaption: "Ok",
    // }
    // this.messageDialogService.shoNotificationDialog(dlgData).subscribe(result => {
    //   console.log(result)
    //   if (result == 'Ok') {
    //     this.redirectParams = null;
    //     this.router.navigate([], {
    //       relativeTo: this.route,
    //       queryParams: {},
    //       replaceUrl: true
    //     });
    //     sessionStorage.removeItem(SESSION_OPERATION_MODE);
    //     this.router.navigate(['/']);
    //   }
    // });
  }
}

